<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <i class="fa fa-list"></i> Empresas
            <router-link
              class="pull-right btn btn-sm btn-success text-white"
              to="/empresas/crear-empresa"
            >
              <i class="fa fa-plus" /> Nueva
            </router-link>
          </div>
          <table class="table table-condensed table-striped table-hover">
            <thead>
              <tr>
                <th>
                  <a @click="ordenar('nombre')" href="#">
                    Nombre
                    <span v-show="order_by == 'nombre' ">
                      <i class="fa fa-sort-alpha-asc" v-show="!reverse" />
                      <i class="fa fa-sort-alpha-desc" v-show="reverse" />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.nombre"
                    v-on:keyup.enter="getEmpresas()"
                  />
                </th>

                <th>
                  <a @click="ordenar('ruc')" href="#">
                    RUC
                    <span v-show="order_by == 'ruc' ">
                      <i class="fa fa-sort-alpha-asc" v-show="!reverse" />
                      <i class="fa fa-sort-alpha-desc" v-show="reverse" />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.ruc"
                    v-on:keyup.enter="getEmpresas()"
                  />
                </th>


                <th>
                  <a @click="ordenar('codigo')" href="#">
                    Codigo
                    <span v-show="order_by == 'codigo' ">
                      <i class="fa fa-sort-alpha-asc" v-show="!reverse" />
                      <i class="fa fa-sort-alpha-desc" v-show="reverse" />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.codigo"
                    v-on:keyup.enter="getEmpresas()"
                  />
                </th>
                <th>
                  <a @click="ordenar('mes_cierre_fiscal')" href="#">
                    Mes cierre
                    <span v-show="order_by == 'mes_cierre_fiscal' ">
                      <i class="fa fa-sort-alpha-asc" v-show="!reverse" />
                      <i class="fa fa-sort-alpha-desc" v-show="reverse" />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.mes_cierre_fiscal"
                    v-on:keyup.enter="getEmpresas()"
                  />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="{id, nombre, ruc, codigo, mes_cierre_fiscal} in registros" :key="id">
                <td>{{nombre}}</td>
                <td>{{ruc}}</td>
                <td>{{codigo}}</td>
                <td>{{mes_cierre_fiscal}}</td>
                <td>
                  <router-link class="pull-right" :to="'/empresas/'+ id">
                    <i class="fa fa-pencil" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
            @input="getEmpresas"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "EmpresasTable",
  data: () => {
    return {
      cargando: false,
      reverse: false,
      order_by: null,
      registros: [],
      model: {
        nombre: null,
        codigo:null,
        ruc:null
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1
    };
  },
  created() {
    this.getEmpresas();
  },
  methods: {
    async ordenar(campo) {
      this.reverse = !this.reverse;
      this.order_by = campo;
      this.getEmpresas();
    },
    async getEmpresas() {
      try {
        this.cargando = true;
        // eslint-disable-next-line no-undef
        const {data} = await axios.post("/api/catalogos/empresas-list", {
          perPage: this.perPage,
          currentPage: this.currentPage,
          order_by: this.order_by,
          tipoOrder: this.reverse ? "asc" : "desc",
          model: this.model
        });

        this.cargando = false;
        this.registros = data.data;
        this.totalRows = data.total;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style>
.table th,
.table td {
  padding: 0.3em;
}
</style>
